import { MapGeoJSONFeature } from "maplibre-gl";
import { GeoJsonlookfor } from '@geolonia/geojson-lookfor';

/* ***************** 
 * featureの検索処理
 * *****************/ 
export const searchFeatures = ( features: MapGeoJSONFeature[] | undefined, keywords: string ): MapGeoJSONFeature[] | undefined => {

    if(!features || features.length === 0) { return undefined; }
            
    const gl = new GeoJsonlookfor({
        "type": "FeatureCollection",
        "features": features
    });
    
    const result = gl.match(keywords, { excludeKeys: ['_id'] }).getGeoJSON();
    if(!result || result.features.length === 0) { return undefined; }

    return result.features;
}
